module.exports = __webpack_public_path__ + "static/Icons_DownpAssist_inactive-b4b9b9bf26b1b417e301323d41bbcb20.png";